import React from "react";

import {
	TableBody,
	TableCell,
	TableRow,
} from "@mui/material";
import { formatCurrency, formatLabel } from "../../../utils/utilityFunctions"
import moment from "moment";
// import './style.css';

export default function LedgerSummaryBreakdown(props) {

	const getBusinessName = (businessId) => {
		if (!props.businessList) return businessId;
		const business = props.businessList.find(b => b.id === businessId);
		return business ? `${business.name} (${businessId})` : businessId;
	};

	return (
		<>
			<TableBody>
				<TableRow >
					<TableCell
						align="left"
						variant="body2"
					>
						{moment(props.data.createdDate).format("MMM D, y")}
					</TableCell>
					<TableCell
						align="left"
						variant="body2"
					>
						{props.data.transactionId}
					</TableCell>
				<TableCell align="center" variant="body2">
					{getBusinessName(props.data.businessId)}
				</TableCell>
					<TableCell align="right" variant="body2">
						{props.data.transactionType}
					</TableCell>
					<TableCell align="center" variant="body2">
						{props.data.orderId}
					</TableCell>
					<TableCell
						align="left"
						variant="body2"
					>
						{formatLabel(props.data.description)}
					</TableCell>
					<TableCell
						align="right"
						variant="body2"
					>
						{props.data.entryType === 'D' && formatCurrency(props.data.amount)}
					</TableCell>
					<TableCell
						align="right"
						variant="body2"
					>
						{props.data.entryType === 'C' && formatCurrency(props.data.amount)}
					</TableCell>
					<TableCell
						align="center"
						variant="body2"
					>
					</TableCell>
				</TableRow>

			</TableBody>
		</>
	)
}